/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const GithubBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path d="M12 2C6.475 2 2 6.475 2 12c0 4.7 3.225 8.6 7.575 9.7a1.35 1.35 0 0 1-.075-.475v-1.7H8.25c-.675 0-1.3-.3-1.575-.851-.325-.6-.375-1.525-1.2-2.1-.25-.2-.05-.4.225-.376.525.15.95.5 1.35 1.025.4.525.575.65 1.324.65.35 0 .9-.024 1.4-.1.275-.7.75-1.325 1.326-1.625-3.35-.4-4.95-2.05-4.95-4.3 0-.976.424-1.9 1.125-2.7-.225-.776-.525-2.376.1-3 1.5 0 2.4.975 2.625 1.224.75-.25 1.575-.4 2.425-.4.875 0 1.675.15 2.424.4.225-.25 1.126-1.225 2.625-1.225.6.6.325 2.225.075 3 .7.776 1.1 1.725 1.1 2.7 0 2.25-1.575 3.901-4.9 4.25.926.476 1.576 1.826 1.576 2.826V21.2c0 .075-.025.15-.025.225 3.9-1.35 6.7-5.05 6.7-9.425 0-5.525-4.475-10-10-10Z" /></svg>);
const Github = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={GithubBase} {...rest} ref={ref} />);
export default Github;